import "bootstrap/dist/css/bootstrap.min.css";
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { FaCarCrash } from "react-icons/fa";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    ChartDataLabels
);

const DowntimeByVehicle = ({ vehicleData = [] }) => {
    const dataValues = vehicleData.map((item) => Number(item.total_cost));

    const data = {
        labels: ["V001", "V002", "V003", "V004", "V005"],
        datasets: [
            {
                label: "Total Cost (₨)",
                data: dataValues,
                backgroundColor: "#2dc2ff", // Light blue bar color
                borderRadius: 6,
                barThickness: 40,
            },
        ],
    };

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: { display: false },
            datalabels: {
                anchor: "end",
                align: "start", // label above the bar
                color: "blue",
                font: {
                    weight: "bold",
                    size: 14,
                },
                formatter: (value) => `${value}`,
            },
            tooltip: {
                callbacks: {
                    label: (context) => `Rs ${Number(context.raw).toLocaleString()}`,
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: { display: true }, // Show Y axis values
                grid: { drawTicks: true },
            },
            x: {
                title: {
                    display: true,
                    text: "Maintenance Type",
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                },
            },
        },
    };

    return (
        <div className="downtime-widget">
            <div className="widget-header">
                <h3 className="widget-title">
                    <FaCarCrash color="#4F19E2" size={24} />
                    Downtime by Vehicle
                </h3>
            </div>

            {vehicleData.length === 0 ? (
                <h6 style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '250px',
                    fontSize: '22px',
                    textTransform: "capitalize"
                }}>
                    No data found
                </h6>
            ) : (
                <div className="overflow-auto">
                    <div
                        style={{
                            width: `100%`,
                            height: "400px",
                        }}
                    >
                        <Bar data={data} options={options} plugins={[ChartDataLabels]} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DowntimeByVehicle;
